import instance from "../../utils/axios";

export const getClientID = async (clientCode) => {
  return await instance.post("/get-id-with-code", clientCode);
};
